import React from 'react';

import { CustomButton } from '../../blockButton';
import { CustomDivider } from '../../blockDivider';
import { CustomHeading } from '../../blockHeading';
import { CustomHtml } from '../../blockHtml';
import { CustomImage } from '../../blockImage';
import { CustomSpacer } from '../../blockSpacer';
import { CustomText } from '../../blockText';
import { CustomSuccessMessage } from '../../blockSuccessMessage';
import { CustomErrorMessage } from '../../blockErrorMessage';

import ColumnsContainerReader from '../blocks/ColumnsContainer/ColumnsContainerReader';
import ContainerReader from '../blocks/Container/ContainerReader';
import { FormInput } from '../../../formBlocks/blockInput';
import { FormSelect } from '../../../formBlocks/blockSelect';
import { FormDynamic } from '../../../formBlocks/blockDynamic';
import { FormCascader } from '../../../formBlocks/blockCascader';
import { FormRadio } from '../../../formBlocks/blockRadio';
import { FormCheckbox } from '../../../formBlocks/blockCheckbox';
import { FormSwitch } from '../../../formBlocks/blockSwitch';
import { FormPicker } from '../../../formBlocks/blockPicker';
import { FormTimePicker } from '../../../formBlocks/blockTimePicker';
import { FormUpload } from '../../../formBlocks/blockUpload';
import { FormRate } from '../../../formBlocks/blockRate';
import { Submit } from '../../../formBlocks/blockSubmit';
import { FormOtp } from '../../../formBlocks/blockOtp';
import { FormSlider } from '../../../formBlocks/blockSlider';
import { FormLinear } from '../../../formBlocks/blockLinear';
import { FormUnSubForm } from '../../../formBlocks/blockUnSubForm';
import { FormPhoneWithArea } from '../../../formBlocks/blockPhoneWithArea';
import { FormDisplayTexts } from '../../../formBlocks/blockDisplayTexts';

function BaseReaderBlock (props) {
  const {type, data, form_data, fCode, cmCode, fieldSource, otherCustom, prefixFieldSource, formRef, handleAlertError,
    otpLoading,
    canSendOtp,
    waitOtpSeconds,
    validateOtpResult,
    validateOtpLoading,
    handleStartSendOtp,
    handleChangeOTP,
    handleChangeEmail,
    allFieldValues,
    setAllFieldValues,
    formClientWidth,
    unSubData,
    errorMessage,
    successMessage,
    recaptcha
  } = props;
  switch(type) {
    case 'ColumnsContainer': {
      return <ColumnsContainerReader style={data.style} props={data.props} form_data={form_data} fCode={fCode} cmCode={cmCode}
        formClientWidth={formClientWidth} unSubData={unSubData} formRef={formRef} handleAlertError={handleAlertError} otpLoading={otpLoading}
        canSendOtp={canSendOtp} waitOtpSeconds={waitOtpSeconds} validateOtpResult={validateOtpResult} validateOtpLoading={validateOtpLoading}
        handleStartSendOtp={handleStartSendOtp} handleChangeOTP={handleChangeOTP} handleChangeEmail={handleChangeEmail} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues}
        errorMessage={errorMessage}
        successMessage={successMessage}
        recaptcha={recaptcha}
      />
    }
    case 'Container': {
      return <ContainerReader style={data.style} props={data.props} form_data={form_data} fCode={fCode} cmCode={cmCode}
        formClientWidth={formClientWidth} unSubData={unSubData} formRef={formRef} handleAlertError={handleAlertError} otpLoading={otpLoading}
        canSendOtp={canSendOtp} waitOtpSeconds={waitOtpSeconds} validateOtpResult={validateOtpResult} validateOtpLoading={validateOtpLoading}
        handleStartSendOtp={handleStartSendOtp} handleChangeOTP={handleChangeOTP} handleChangeEmail={handleChangeEmail} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues}
        errorMessage={errorMessage}
        successMessage={successMessage}
        recaptcha={recaptcha}
      />
    }
    case 'Button': {
      return <CustomButton style={data.style} props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Divider': {
      return <CustomDivider style={data.style} props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Heading': {
      return <CustomHeading style={data.style} props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Html': {
      return <CustomHtml style={data.style} props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Image': {
      return <CustomImage style={data.style} props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Spacer': {
      return <CustomSpacer props={data.props} formClientWidth={formClientWidth}/>
    }
    case 'Text': {
      return <CustomText style={data.style} props={data.props} formClientWidth={formClientWidth} unSubData={unSubData}/>
    }
    case 'SuccessMessage': {
      return <CustomSuccessMessage style={data.style} props={data.props} formClientWidth={formClientWidth} unSubData={unSubData}
        successMessage={successMessage}
      />
    }
    case 'ErrorMessage': {
      return <CustomErrorMessage style={data.style} props={data.props} formClientWidth={formClientWidth} unSubData={unSubData}
        errorMessage={errorMessage}
      />
    }

    // form blocks:
    case 'Input': {
      return <FormInput form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} prefixProps={data.prefixProps}
        formRef={formRef} validateOtpLoading={validateOtpLoading}
        handleChangeEmail={handleChangeEmail} 
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} prefixFieldSource={prefixFieldSource} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Phone_with_area': {
      return <FormPhoneWithArea form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} prefixProps={data.prefixProps}
        formRef={formRef} validateOtpLoading={validateOtpLoading}
        handleChangeEmail={handleChangeEmail} 
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Select': {
      return <FormSelect form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Dynamic': {
      return <FormDynamic form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Cascader': {
      return <FormCascader form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Radio': {
      return <FormRadio form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Checkbox': {
      return <FormCheckbox form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle}
        formRef={formRef} 
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Switch': {
      return <FormSwitch form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Picker': {
      return <FormPicker form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'TimePicker': {
      return <FormTimePicker form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Upload': {
      return <FormUpload form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef} handleAlertError={handleAlertError} 
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Rate': {
      return <FormRate form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Slider': {
      return <FormSlider form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'Linear': {
      return <FormLinear form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        formRef={formRef}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'OTP': {
      return <FormOtp form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle} 
        messageProps={data.messageProps} buttonStyle={data.buttonStyle}
        formRef={formRef} handleAlertError={handleAlertError} 
        otpLoading={otpLoading}
        canSendOtp={canSendOtp}
        waitOtpSeconds={waitOtpSeconds}
        validateOtpResult={validateOtpResult}
        validateOtpLoading={validateOtpLoading}
        handleStartSendOtp={handleStartSendOtp}
        handleChangeOTP={handleChangeOTP}
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode}
      />
    }
    case 'unSubForm': {
      return <FormUnSubForm form_data={form_data} style={data.style} props={data.props} formStyle={data.formStyle}
        formRef={formRef} 
        allFieldValues={allFieldValues}
        setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth} unSubData={unSubData}
      />
    }
    case 'Submit': {
      return <Submit form_data={form_data} style={data.style} disableStyle={data.disableStyle} buttonStyle={data.buttonStyle} formClientWidth={formClientWidth}
        unSubData={unSubData}
        recaptcha={recaptcha}
      />
    }
    case 'Display_texts': {
      return <FormDisplayTexts style={data.style} props={data.props} 
        allFieldValues={allFieldValues} setAllFieldValues={setAllFieldValues} formClientWidth={formClientWidth}
        fieldSource={fieldSource} otherCustom={otherCustom} fCode={fCode} cmCode={cmCode} 
      />
    }
    default: 
      return ''
  }
};
export function ReaderBlock({ id, fCode, cmCode, formData, formRef, handleAlertError,
  otpLoading,
  canSendOtp,
  waitOtpSeconds,
  validateOtpResult,
  validateOtpLoading,
  handleStartSendOtp,
  handleChangeOTP,
  handleChangeEmail,
  allFieldValues,
  setAllFieldValues,
  formClientWidth,
  unSubData,
  errorMessage,
  successMessage,
  recaptcha
}) {
  return <BaseReaderBlock
    form_data={formData}
    type= {formData[id].type}
    data={formData[id].data}
    fCode={fCode}
    cmCode={cmCode}
    fieldSource={formData[id].fieldSource || null}
    otherCustom={formData[id].otherCustom || null}
    prefixFieldSource={formData[id].prefixFieldSource || null}
    formRef={formRef}
    handleAlertError={handleAlertError}
    otpLoading={otpLoading}
    canSendOtp={canSendOtp}
    waitOtpSeconds={waitOtpSeconds}
    validateOtpResult={validateOtpResult}
    validateOtpLoading={validateOtpLoading}
    handleStartSendOtp={handleStartSendOtp}
    handleChangeOTP={handleChangeOTP}
    handleChangeEmail={handleChangeEmail}
    allFieldValues={allFieldValues}
    setAllFieldValues={setAllFieldValues}
    formClientWidth={formClientWidth}
    unSubData={unSubData}
    errorMessage={errorMessage}
    successMessage={successMessage}
    recaptcha={recaptcha}
  />;
}
